import { CompositeDecorator, ContentBlock, ContentState } from 'draft-js';
import { useState } from 'react';
import { Box, Button, Flex, Text } from 'rebass/styled-components';
import { InputNoForm } from '../../../../components/TextInput';


export const findImageEntities=(contentBlock:any, callback:any, contentState:any) =>{
  contentBlock.findEntityRanges(
    (character:any) => {
      const entityKey = character.getEntity();
      // console.log(contentState.getEntity(entityKey).getType())
      return (
        entityKey !== null &&
        contentState.getEntity(entityKey).getType() === 'IMAGE'
      );
    },
    callback
  );
}

export const Image = (props: any) => {
  const {
    height,
    src,
    width,
  } = props.contentState.getEntity(props.entityKey).getData();
// console.log('img', {height, src, width})
  return (
    <img src={src} height={height} width={width} />
  );
};

export const findLinkEntities = (contentBlock: ContentBlock, callback: any, contentState: ContentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
  }, callback);
};

export const Link = (props: any) => {
  const { link, text } = (props.contentState as ContentState).getEntity(props.entityKey).getData()

  return (
    <a style={{ textDecoration: 'underline' }} href={link} target='_blank' >
      {text || props.children}
    </a>
  )
}

export const linkDecorator = new CompositeDecorator([
  {
    strategy: findLinkEntities,
    component: Link,
  },
  // {
  //   strategy: findImageEntities,
  //   component: Image,
  // },
]);

export const createLinkDecorator = () =>{
  return linkDecorator
}

export const linkDecorators = [
  {
    strategy: findLinkEntities,
    component: Link,
  },
  // {
  //   strategy: findImageEntities,
  //   component: Image,
  // },
];

export const InsertLinkModalContent = ({ okPressed, onCancel }: { okPressed: (text: string, link: string) => void, onCancel: () => void }) => {
  const [text, setText] = useState<string>('');
  const [link, setLink] = useState<string>('');
  return (
    <Flex flexDirection={'column'}
      padding={4}
      style={{
        background: 'white',
        borderRadius: '20px',
        minWidth: '500px'
      }}>
      <Text mb={3}>Link</Text>
      <Box style={{ width: '100%', height: '1px', backgroundColor: '#d5dce1' }} />

      <Flex mt={3} flexDirection={'column'}>
        <Text>URL</Text>
        <InputNoForm value={link} style={{fontSize:'12px'}} onChange={(e: any) => setLink(e.target.value)} />
        <Text mt={3}>Text</Text>
        <InputNoForm value={text} style={{fontSize:'12px'}} onChange={(e: any) => setText(e.target.value)} />
      </Flex>
      <Flex mt={5} flexDirection='row' alignItems={'center'} justifyContent='center' style={{ width: '100%' }}>
        <Button variant={'primary'} mr={3} style={{ borderRadius: '8px' }} disabled={!text || !link} onClick={() => {
          okPressed(link, text)

        }}>Insert</Button>
        <Button variant={'white'} ml={3} onClick={() => onCancel()}>Cancel</Button>
      </Flex>
    </Flex>
  )
}